import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as Middleware from "@middlewares/index";

interface PropsInterface {}

interface StateInterface {}

class UserHasNotNetworking extends React.Component<
  PropsInterface,
  StateInterface
> {
  public render() {
    return (
      <>
        <div className="modal modal--has-no-profile">
          <div className="modal__header">
            <div className="modal__title">Профиль неактивен</div>
            <button
              className="modal__close"
              onClick={() => {
                Middleware.Ui.Modal.close();
              }}
            />
          </div>
          <div className="modal__body">
            <div className="modal__desc">
              Страница недоступна. Похоже,{" "}
              {this.props.Store.Profile.data.firstName}{" "}
              {this.props.Store.Profile.data.lastName} больше не использует
              нетворкинг!.
            </div>
          </div>
          <div className="modal__footer">
            <Link
              className="btn btn--grey"
              to="#"
              onClick={() => Middleware.Ui.Modal.closeAll()}
            >
              Понятно!
            </Link>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: any) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(UserHasNotNetworking)
);
